export const btn_link={
    payment: "/payment",
    pendingPayment: "/pending-payment",
    refundPayment: "/refund-payment",
    trashPayment: "/trash-payment",
}